import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TENANT_FEATURES } from '../../core/services/tenant-feature.service';
import { LvrButton } from '../../core/components/lvr-button/lvr-button';
import { resolveTenantMailRecipient } from '../../shared/helpers/tenant-mail-recipient.func';

@Component({
	selector: 'lvr-error-page',
	templateUrl: './error.html',
	styleUrl: './error.scss',
	imports: [TranslocoPipe, LvrButton],
})
export class ErrorPage {
	private readonly router = inject(Router);
	private readonly tenantFeatures = inject(TENANT_FEATURES);
	private readonly bugReportSubject = 'Fehlerbericht KlifdWeb';

	public requestBugReport() {
		const body = [
			'Hallo,',
			'',
			'ich möchte einen Fehler melden.',
			'Auftragsnummer:',
			'Kurzbeschreibung des Problems:',
			'Was habe ich gemacht:',
			'Was wird mir angezeigt:',
			'Was sollte mir angezeigt werden:',
			'Datum & Uhrzeit:',
			'Screenshot (optional)',
			'',
		].join('\n');

		const recipient = resolveTenantMailRecipient(this.tenantFeatures.tenant());
		this.openMailto(this.buildMailto(recipient, this.bugReportSubject, body));
	}

	public goToOverview() {
		this.router.navigate(['/']);
	}

	private openMailto(href: string): void {
		window.location.href = href;
	}

	private buildMailto(recipient: string, subject: string, body: string): string {
		return `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
	}
}
